<template>
  <div>
    <v-card elevation="0" class="pa-4">
      <custom-tabs v-model="tab" :tab-items="tabis" grow>
        <template v-slot:staticItems>
          <v-tab-item>
            <v-card v-if="advertising.active" elevation="0" class="w-100">
              <v-list-item two-line>
                <v-card-title
                  >برای رزرو بنر تبلیغاتی تاریخ شروع و اتمام راوارد
                  کنید</v-card-title
                >
              </v-list-item>

              <v-row class="w-100 pa-2">
                <!-- <v-col cols="12" md="6">
                  <date-picker
                    v-model="bannerSelect.start_time"
                    clearable
                    display-format="jYYYY-jMM-jDD"
                    format="YYYY-MM-DD"
                    label="از تاریخ"
                  />
                </v-col> -->
                <!-- <v-col cols="12" md="6">
                  <date-picker
                    v-model="bannerSelect.end_time"
                    clearable
                    display-format="jYYYY-jMM-jDD"
                    format="YYYY-MM-DD"
                    label="تا تاریخ"
                  />
                </v-col> -->
              </v-row>

              <v-card-actions>
                <v-btn
                  color="green"
                  @click="reserveBannerHandler"
                  class="w-100"
                  outlined
                >
                  رزرو بنر
                  <v-icon>mdi-content-save-check</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-else class="w-100 d-flex justify-content-center">
              <v-card-title>
                در حال حاضر لیستی برای اجاره بنر تبلیغاتی وجود ندارد
              </v-card-title>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <reserve-space />
          </v-tab-item>
        </template>
      </custom-tabs>
    </v-card>

    <custom-popup v-model="reserve" :cons="cons">
      <reserve-banner v-model="bannerSelect" />
    </custom-popup>
  </div>
</template>

<script>
import reserveBanner from "../../components/reserveBanner.vue";
import reserveSpace from "../../components/reserveSpace.vue";
export default {
  components: { reserveBanner, reserveSpace },
  name: "commercialListItemSixUser",
  data() {
    return {
      tab: null,
      advertising: {
        active: true,
        number: 1,

        pay: {
          day: 1000,
          week: 1200,
          month: 1300,
          treeMonth: 1400,
          sixMonth: 1500,
          year: 3000,
        },
      },
      //   select time banner
      time: 0,

      //   bannerSelect
      bannerSelect: {},
      // persian banner
      payLabels: ["روزانه", "هفتگی", "ماهانه", "سه ماهه", "شش ماهه", "یک ساله"],
      //   pop up
      reserve: false,
      cons: { title: "رزرو بنر تبلیغاتی" },

      // time
      time: {
        start_time: "",
        end_time: "",
      },
      // tabs
      tabis: [
        {
          text: "اجاره بنر تبلیغاتی",
          value: "banner",
          icon: "panorama-variant-outline",
        },
        {
          text: "اجاره فضای تبلیغاتی",
          value: "space",
          icon: "view-grid-outline",
        },
      ],
    };
  },

  watch: {
    time: {
      immediate: true,
      deep: true,
      handler(val) {
        this.bannerSelect = {
          start_time: "",
          end_time: "",
          banner: null,
          discription: "",
        };
      },
    },
    reserve(val) {
      if (!val) {
        this.bannerSelect = {
          start_time: "",
          end_time: "",
          banner: "",
          discription: "",
        };
      }
    },
  },

  methods: {
    reserveBannerHandler() {
      if (
        this.bannerSelect.start_time.length > 0 &&
        this.bannerSelect.end_time.length > 0
      ) {
        this.reserve = true;
      } else {
        this.$toast.error("تاریخ شروع و پایان نمیتواند خالی باشد");
      }
    },
  },
};
</script>

<style></style>
